module.exports = __webpack_public_path__ + "static/media/flat-view-controls-icon.948b23f2.svg";